var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceSky01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1967.67 435.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n        mix-blend-mode: screen;\n        opacity: .2;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 985.57,
    cy: 217.79,
    fx: 985.57,
    fy: 217.79,
    r: 701.86,
    gradientTransform: "translate(-17.45) scale(1.02 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31144f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1592.64,0c-49.1,38.54-136.17,84.73-282.5,102.91-184.08,22.87-317-52.51-383.06-102.91H0v161.28c72.49-18.59,154.23-21.61,226.61,19.1,183.65,103.29,351.56,276.31,472.24,253.07,120.68-23.24,112.81-201.42,18.36-188.51-94.45,12.91,23.9,50.46.15,87.21-23.76,36.75-147.07-9.74-133.95-79.46,13.12-69.72,165.28-183.35,299.09-64.56,133.8,118.79,393.53,255.65,598.17,111.04,174.28-123.16,297.18-227.58,487-212.79V0h-375.03Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceSky01);
export default __webpack_public_path__ + "static/media/SPACE_SKY_01.0374dc8be1d920c47e133647a013106a.svg";
export { ForwardRef as ReactComponent };